import React, { useMemo } from 'react'
import { Document } from '@contentful/rich-text-types'
import { InfoPopover, TextBlock, Type } from '@/components/common'
import { popupOverride } from '@/components/common/Popover/InfoPopover'

interface Props {
  stat: string
  title?: string
  info?: Document
  subtitle?: string
}

const DetailsRow: React.FC<Props> = ({ stat, title, info, subtitle }) => {
  const popover = useMemo(
    () =>
      info && (
        <TextBlock
          document={info}
          className="!mb-0"
          optionOverrides={popupOverride}
        />
      ),
    [info]
  )

  return (
    <div>
      <div className="flex items-end gap-1">
        <Type as="span" variant="title-lg" className="font-semibold">
          {stat}
        </Type>
        {title && (
          <Type as="span" variant="title-sm" className="text-core-gray-800">
            {title}
          </Type>
        )}
        {popover && (
          <InfoPopover content={popover} className="mb-1 text-core-oxide" />
        )}
      </div>
      {subtitle && (
        <Type
          as="p"
          variant="paragraph-md"
          className="font-light text-core-gray-600"
        >
          {subtitle}
        </Type>
      )}
    </div>
  )
}

export default DetailsRow
